import { NavItem } from '@app/components/layout/sidenav/link/NavItem';
import { CanByRole } from '@app/core/auth/authorization/components/CanByRole';
import { UserRole } from '@mi-front/core';
import { FormattedMessage } from 'react-intl';
import StreamerBoxIcon from '../components/StreamerBoxIcon';

export function StreamerBoxLinks() {
  return (
    <CanByRole role={[UserRole.CLIENT_ADMIN, UserRole.SUPERADMIN]}>
      <NavItem to="/streamer-box" icon={<StreamerBoxIcon />}>
        <FormattedMessage id="streamerBox.nav.title" defaultMessage="Streamer Box" />
      </NavItem>
    </CanByRole>
  );
}
